export default "__VITE_ASSET__BXUFXjfb__"